import React, { useState, useEffect } from 'react';
import Modal from './UI/Modal';
import { FaWhatsapp } from 'react-icons/fa';
import { congregacaoService } from '../services/api';

/**
 * Modal para coletar dados do template de mensagem WhatsApp antes de exportar.
 * @param {boolean}  isOpen
 * @param {function} onClose
 * @param {function} onExportar - recebe { nomeAuxiliar, localidade, recitativo }
 * @param {number}   totalMembros
 */
const ModalExportWhatsApp = ({ isOpen, onClose, onExportar, totalMembros = 0 }) => {
  const [nomeAuxiliar, setNomeAuxiliar] = useState('');
  const [localidade, setLocalidade]   = useState('');
  const [recitativo, setRecitativo]   = useState('');
  const [congregacoes, setCongregacoes] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    let mounted = true;
    congregacaoService.getAtivas()
      .then((resp) => {
        if (!mounted) return;
        const nomes = (resp?.data || [])
          .map((c) => c.nome || c.nomeCompleto || c.nome_curto)
          .filter(Boolean);
        setCongregacoes(nomes);
      })
      .catch(() => { /* silencia */ });
    return () => { mounted = false; };
  }, [isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nomeAuxiliar.trim() || !localidade.trim() || !recitativo.trim()) return;
    onExportar({
      nomeAuxiliar: nomeAuxiliar.trim(),
      localidade:   localidade.trim(),
      recitativo:   recitativo.trim(),
    });
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Exportar contatos para WhatsApp"
      size="sm"
    >
      <form onSubmit={handleSubmit}>
        <p style={{ fontSize: '.87rem', color: '#475569', margin: '0 0 16px' }}>
          Preencha os dados abaixo. Um arquivo <strong>.html</strong> será gerado com os{' '}
          <strong>{totalMembros}</strong> contato{totalMembros !== 1 ? 's' : ''} — ao abrir
          no navegador, basta clicar no telefone para iniciar a conversa no WhatsApp com a
          mensagem já escrita.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <label style={labelStyle}>
            Seu nome (auxiliar)
            <input
              type="text"
              value={nomeAuxiliar}
              onChange={(e) => setNomeAuxiliar(e.target.value)}
              placeholder="Ex: João Silva"
              required
              style={inputStyle}
            />
          </label>

          <label style={labelStyle}>
            Localidade da reunião de jovens
            <select
              value={localidade}
              onChange={(e) => setLocalidade(e.target.value)}
              required
              style={inputStyle}
            >
              <option value="">Selecione a localidade…</option>
              {congregacoes.map((nome) => (
                <option key={nome} value={nome}>{nome}</option>
              ))}
            </select>
          </label>

          <label style={labelStyle}>
            Recitativo — versículo inicial (livro capítulo:verso)
            <input
              type="text"
              value={recitativo}
              onChange={(e) => setRecitativo(e.target.value)}
              placeholder="Ex: Salmos 23:1"
              required
              style={inputStyle}
            />
            <span style={{ fontSize: '.78rem', color: '#64748b', marginTop: '2px', lineHeight: 1.5 }}>
              Formato: <strong>Livro Capítulo:Verso</strong> (ex: Salmos 23:1)<br />
              Para jovens (3ª turma) o verso é incrementado automaticamente a cada membro.<br />
              Para crianças (1ª/2ª turma) todos recebem o mesmo versículo.
            </span>
          </label>
        </div>

        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '20px' }}>
          <button type="button" onClick={onClose} style={btnCancelStyle}>
            Cancelar
          </button>
          <button type="submit" style={btnSubmitStyle}>
            <FaWhatsapp size={15} /> Gerar HTML
          </button>
        </div>
      </form>
    </Modal>
  );
};

const labelStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  fontSize: '.87rem',
  fontWeight: 600,
  color: '#1e293b',
};

const inputStyle = {
  padding: '8px 10px',
  borderRadius: '6px',
  border: '1px solid #cbd5e1',
  fontSize: '.87rem',
  width: '100%',
  outline: 'none',
};

const btnCancelStyle = {
  padding: '8px 16px',
  borderRadius: '6px',
  border: '1px solid #cbd5e1',
  background: '#fff',
  cursor: 'pointer',
  fontSize: '.87rem',
  color: '#475569',
};

const btnSubmitStyle = {
  padding: '8px 18px',
  borderRadius: '6px',
  border: 'none',
  background: '#16a34a',
  color: '#fff',
  cursor: 'pointer',
  fontSize: '.87rem',
  fontWeight: 600,
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
};

export default ModalExportWhatsApp;
